// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".family-status[data-v-b1a4b70c] {\n  padding-top: 6px;\n  width: 100%;\n}\n.children[data-v-b1a4b70c] {\n  margin-top: 25px;\n}\n@media (min-width: 768px) {\n.family-status[data-v-b1a4b70c] {\n    width: calc(100% / 10 * 3);\n    padding-right: 15px;\n}\n}\n@media (min-width: 992px) {\n.family-status[data-v-b1a4b70c] {\n    width: calc(100% / 12 * 3);\n}\n}\n", ""]);
// Exports
module.exports = exports;
